import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_TRANSLATIONS } from './data/constants';

const getPageId = (pathname: string) => {
  const pathWithoutLanguage = pathname.replace(/^\/(ro|en)(?=\/|$)/, '') || '/';

  for (const page of Object.keys(ROUTE_TRANSLATIONS.ro) as Array<keyof typeof ROUTE_TRANSLATIONS.ro>) {
    if (
      pathWithoutLanguage === ROUTE_TRANSLATIONS.ro[page] ||
      pathWithoutLanguage === ROUTE_TRANSLATIONS.en[page]
    ) {
      return page;
    }
  }

  return pathWithoutLanguage;
};

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const pageId = getPageId(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageId]);

  return null;
};

export default ScrollToTop;
